import React from "react";
import { Typography } from "@material-ui/core";
import moment from "moment";
import { isCanadaReport } from "../../../utils/reportCountry";

const ReportPageFooter = ({ reportDetails }) => {
  const isCanada = isCanadaReport(reportDetails);
  const rawGenerated =
    reportDetails?.generated_date ?? reportDetails?.generatedDate ?? null;

  const parsed = rawGenerated
    ? moment(rawGenerated, [
        "MM/DD/YYYY",
        "MM-DD-YYYY",
        "YYYY-MM-DD",
        moment.ISO_8601,
      ])
    : moment();
  const generated = parsed.isValid()
    ? parsed.format("MM-DD-YYYY")
    : moment().format("MM-DD-YYYY");

  return (
    <div
      style={{
        position: "absolute",
        right: 20,
        bottom: 8,
      }}
    >
      <Typography
        variant="body2"
        style={{
          fontWeight: 300,
          fontSize: "10px",
          color: "#585858",
        }}
      >
        {isCanada
          ? `Report Generated on/Rapport genere le ${generated}`
          : `Report Generated on ${generated}`}
      </Typography>
    </div>
  );
};

export default ReportPageFooter;
